// The locales both storefronts serve. Client-safe: imported by the language
// switcher. Each app's `lib/i18n/locales.ts` re-exports this and declares its
// own DEFAULT_LOCALE — the one place the storefronts differ (Formed pt-br,
// ASCPS en).
export const SUPPORTED_LOCALES = ['en', 'pt-br', 'es'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_TO_BCP47: Record<Locale, string> = {
  'en': 'en-US',
  'pt-br': 'pt-BR',
  'es': 'es-ES',
}

export const LOCALE_LABELS: Record<Locale, string> = {
  'en': 'English',
  'pt-br': 'Português (Brasil)',
  'es': 'Español',
}

export const LOCALE_COOKIE = 'NEXT_LOCALE'

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}
